<div class="auth-wrapper">
  <div class="auth-content">
      <div class="auth-bg"><span  class="r"></span><span class="r s"></span><span class="r s"></span><span class="r"></span></div>



<form class="card reset-password-form" (submit)="onSubmit($event)">
  <dx-form [formData]="formData" [disabled]="loading" class="card-body text-center">
    
    <dxi-item dataField="icon" class="icon" editorType="dxTextBox">
      <div  class="mb-2"><i class="fa fa-sync fa-2x"></i><h3>Şifre Sıfırla</h3> 
      </div>
    <dxo-label [visible]="false"></dxo-label>
  </dxi-item>

    <dxi-item dataField="email" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'Email', mode: 'email' }">
      <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
      <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
      <dxo-label [visible]="false"></dxo-label>
    </dxi-item>

    <dxi-item itemType="button">
      <dxo-button-options width="100%" type="default" [useSubmitBehavior]="true" [template]="'resetPasswordTemplate'"
        [elementAttr]="{ class: 'submit-button' }">
      </dxo-button-options>
    </dxi-item>
    <dxi-item>
      <div class="login-link">
        <a routerLink="/login">Giriş Ekranına Dön</a>
      </div>
    </dxi-item>

    <ng-container *dxTemplate="let item of 'resetPasswordTemplate'">
      <div>
        <span class="dx-button-text">
          <ng-container *ngIf="loading; else notLoading">
            <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
          </ng-container>
          <ng-template #notLoading>ŞİFREMİ SIFIRLA</ng-template>
        </span>
      </div>>
    </ng-container>

  </dx-form>
</form>
  </div></div>